export const getTasks = /* GraphQL */ `
  query GetResourceTasks($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      name
      tasks {
        id
        sk
        resource {
          id
          sk
          idInc
          name
          createdAt
          updatedAt
          maturity
          priority
          dueAt
          workspaceId
          assignee {
            firstName
            lastName
            avatarHash
            id
          }
        }
      }
    }
  }
`;

export const updateTask = /* GraphQL */ `
  mutation UpdateResource($input: UpdateResourceInput!) {
    updateResource(input: $input) {
      id
      sk
      idInc
      type
      name
      description
      schemaVersion
      maturity
      dueAt
      createdAt
      updatedAt
      assignee {
        id
        firstName
        lastName
        avatarHash
      }
      reviewer {
        id
        firstName
        lastName
        avatarHash
      }
    }
  }
`;

export const createTask = /* GraphQL */ `
  mutation CreateTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      id
      sk
      name
      idInc
      maturity
    }
  }
`;

export const attachTaskToResource = /* GraphQL */ `
  mutation AttachTaskToResource($input: TaskToResourceInput!) {
    attachTaskToResource(input: $input) {
      task
      resource
      name
    }
  }
`;

export const detachTaskFromResource = /* GraphQL */ `
  mutation DetachTaskFromResource($input: TaskToResourceInput!) {
    detachTaskFromResource(input: $input) {
      task
      resource
      name
    }
  }
`;

export const attachTaskProduct = /* GraphQL */ `
  mutation AttachTaskToProduct($input: TaskToResourceInput!) {
    attachTaskOutputToResource(input: $input) {
      task
      resource
      name
    }
  }
`;

export const detachTaskProduct = /* GraphQL */ `
  mutation DetachTaskFromProduct($input: TaskToResourceInput!) {
    detachTaskOutputFromResource(input: $input) {
      task
      resource
      name
    }
  }
`;

export const deleteTask = /* GraphQL */ `
  mutation DeleteTask($input: DeleteTaskInput!) {
    deleteTask(input: $input) {
      id
      sk
      name
    }
  }
`;

export const addTaskAuditItem = /* GraphQL */ `
  mutation AddTaskAuditItem($input: TaskToResourceInput!) {
    addTaskAuditItem(input: $input) {
      task
      resource
      workspaceId
      name
    }
  }
`;
export const removeTaskAuditItem = /* GraphQL */ `
  mutation RemoveTaskAuditItem($input: TaskToResourceInput!) {
    removeTaskAuditItem(input: $input) {
      task
      resource
      workspaceId
      name
    }
  }
`;
